import { Layout } from "layouts/layout";
import { DashboardScreen } from "screens/dashboard/dashboard";
import { InfoScreen } from "screens/info/info";
import { SettingsScreen } from "screens/settings/settings";
import { AlertsScreen } from "screens/alerts/alerts";
import { CaptainSelection } from "screens/captain-selection/captain-selection-screen";
import { PairingScreen } from "screens/pairing/pairing";

export enum Screens {
  Dashboard = "dashboard",
  Alerts = "alerts",
  Pairing = "pairing",
  Info = "info",
  Settings = "settings",
  CaptainSelection = "captainSelection",
}

export const ScreenRoutes = [
  {
    name: Screens.Pairing,
    element: <PairingScreen />,
  },
  {
    name: Screens.CaptainSelection,
    element: <CaptainSelection />,
  },
  {
    name: Screens.Dashboard,
    element: (
      <Layout>
        <DashboardScreen />
      </Layout>
    ),
  },
  {
    name: Screens.Info,
    element: (
      <Layout>
        <InfoScreen />
      </Layout>
    ),
  },
  {
    name: Screens.Alerts,
    element: (
      <Layout>
        <AlertsScreen />
      </Layout>
    ),
  },
  {
    name: Screens.Settings,
    element: (
      <Layout>
        <SettingsScreen />
      </Layout>
    ),
  },
];
